export default __webpack_public_path__ + "static/896-887fae4e43841bcf5e25fac68ba9529d.gif";